import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useRef } from 'react'

const useChannelLandingUrlPolicy = (
  setIndividual,
  disabled = false,
  imported = false
) => {
  const dispatch = useDispatch()
  const { channel } = useSelector(state => state.creative.buildCreative)
  const setIndividualRef = useRef(setIndividual)

  useEffect(() => {
    channel &&
      !disabled &&
      !imported &&
      dispatch(
        setIndividualRef.current(channel.siteUrl.individualSettingYn === 'Y')
      )
  }, [dispatch, channel, setIndividualRef, disabled, imported])
}

export default useChannelLandingUrlPolicy
